import { gql } from '@apollo/client';

export const CARD_SORT_QUERIES = gql`
  query ($projectId: ID!, $testSessionId: ID!) {
    cardSortItems(projectId: $projectId) {
      id
      name
      description
      itemOrder
      createdAt
      updatedAt
      imageUrl
    }
    cardSortCategories(projectId: $projectId, isDefault: true) {
      id
      name
      categoryOrder
      isDefault
      createdAt
      updatedAt
    }
    project(id: $projectId) {
      id
      name
      sortType
      randomCategory
      sortRandom
      tooltipDescription
      uploadImage
      hideName
      instructionsContent
      instructionsTitle
      thankYouContent
      thankYouTitle
      thankYouRedirectLink
      hasMrId
    }
    testSessions(testSessionId: $testSessionId) {
      id
      status
      expiresAt
      tester {
        mrId
        cintId
      }
    }
    recruitParticipantToken(projectId: $projectId) {
      id
      token
    }
  }
`;

export const CREATE_TEST_SESSION_CARD_SORT = gql`
  mutation CreateTestSessionCardSort($testSessionId: ID!, $attributes: TestSessionCardSortAttributes!) {
    createTestSessionCardSort(testSessionId: $testSessionId, attributes: $attributes) {
      testSession {
        id
        tester {
          id
          project {
            id
            testType
          }
        }
        testSessionCardSortCategories {
          id
          categoryOrder
          cardSortCategory {
            id
            name
            categoryOrder
            isDefault
          }
          testSessionCardSortItems {
            id
            itemOrder
            cardSortItem {
              id
              itemOrder
            }
            testSessionCardSortCategory {
              id
              categoryOrder
            }
          }
        }
      }
    }
  }
`;
